import { IInstanceComponentBase, InstanceComponentBase } from "../../shared/instanceComponentBase";
import { AttributeEnums } from "../../shared/utilities/enums/attributeEnums";
import { CustomEventEnums } from "../../shared/utilities/enums/customEventEnums";
import { StringEnums } from "../../shared/utilities/enums/stringEnums";
import { HelperUtils } from "../../shared/utilities/helperUtils";
import { TypeUtils } from "../../shared/utilities/typeUtils";

export interface IReviewWidgetPagerShowMore extends IInstanceComponentBase {
    isEof: boolean;
    page: number;
    isDisabled: boolean;
    selectedRating:number;
    update: (isEof: boolean, page: number, isDisabled: boolean, selectedRating:number) => void;
}

export class ReviewWidgetPagerShowMore extends InstanceComponentBase implements IReviewWidgetPagerShowMore {
    private readonly _handleShowMoreClick;
    
    constructor(public htmlElement: HTMLElement, public isEof: boolean, public page: number, public isDisabled: boolean, public selectedRating:number) {
        super(htmlElement);

        this._handleShowMoreClick = this.handleShowMoreClick.bind(this);
        
        this.attachShowMoreClickEventListener();
    }

    attachShowMoreClickEventListener() {
        console.log('ReviewWidgetPagerShowMore: attachShowMoreClickEventListener');
        this.htmlElement.addEventListener('click', this._handleShowMoreClick);
    }

    removeShowMoreClickEventListener() {
        console.log('ReviewWidgetPagerShowMore: removeShowMoreClickEventListener');
        this.htmlElement.removeEventListener('click', this._handleShowMoreClick);
    }

    handleShowMoreClick(e: Event) {
        console.log('ReviewWidgetPagerShowMore: handleShowMoreClick');
        this.htmlElement.dispatchEvent(this.showMoreCustomEvent(this.isEof, this.page, this.isDisabled, this.selectedRating));
    }

    showMoreCustomEvent(isEof: boolean, page: number, isDisabled: boolean, selectedRating: number) {
        console.log(`ReviewWidgetPagerShowMore: showMoreCustomEvent isEof: ${isEof}  page: ${page} isDisabled: ${isDisabled} selectedRating: ${selectedRating}`);
        return new CustomEvent(CustomEventEnums.ReviewWidgetPagerShowMore, {
            bubbles: true,
            cancelable: true,
            composed: false,
            detail: {
                'isEof': isEof,
                'page': page,
                'isDisabled': isDisabled,
                'selectedRating': selectedRating
            }
        });
    }

    setIsEof(isEof: boolean): void {
        this.isEof = isEof;
    }

    setPage(page: number): void {
        this.page = page;
    }

    setSelectedRating(selectedRating:number): void {
        this.selectedRating = selectedRating;
    }

    setIsDisabledCssClass():void{
        console.log(`ReviewWidgetPagerShowMore: setIsDisabledCssClass - ${this.isDisabled}`);
        if(this.isDisabled){
            this.htmlElement.classList.add(StringEnums.CssClass.LbDisabled);
        }else{
            this.htmlElement.classList.remove(StringEnums.CssClass.LbDisabled);
        }
    }

    setIsDisabled(isDisabled: boolean):void{
        this.isDisabled = isDisabled;
        this.setIsDisabledCssClass();
    }
    
    update(isEof: boolean, page: number, isDisabled: boolean, selectedRating:number): void {
        this.setIsEof(isEof);
        this.setPage(page);
        this.setIsDisabled(isDisabled);
        this.setSelectedRating(selectedRating);
    }

    dispose() {
        try {
            console.log(`ReviewWidgetPagerShowMore: dispose`);
            
            this.removeShowMoreClickEventListener();
          
        } catch (error) {
            console.log('ReviewWidgetPagerShowMore: dispose ERROR', error);
        }
    }
}